import { UpdateSingleBillService } from './services/UpdateSingleBillService';
import type { Init } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type UpdateSingleBillData = MergedDataReturnType<[UpdateSingleBillService]>;

export type UpdateSingleBillHandlers = MergedHandlersReturnType<[UpdateSingleBillService]>;

type TApi = ReturnType<UpdateSingleBillService['api']>;

export class UpdateSingleBillManager extends WithApi<TApi> {
  public updateSingleBillInit = ({ pageStore, queries, mutations, t }: Init) => {
    const [updateSingleBillMutation, createSingleBillMutation] = mutations;

    const [useSingleBill] = queries;

    const pending = useSingleBill.isPending;
    const { error } = useSingleBill;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
      } as const;
    }

    const updateSingleBill = new UpdateSingleBillService(
      pageStore,
      useSingleBill.data,
      updateSingleBillMutation,
      createSingleBillMutation,
      t
    );

    this.initApi({
      ...updateSingleBill.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...updateSingleBill.data(),
      },
      handlers: {
        ...updateSingleBill.handlers(),
      },
    } as const;
  };
}
